import { useMutation } from "@tanstack/react-query";
import { GymNotificationService } from "../../services/gym-notification.service";

export const useUserGymNotificationMutations = () => {
  const { mutate: deleteByGymListingId } = useMutation<any, Error, string>({
    mutationFn: async (gymListingId) => GymNotificationService.deleteByGymListingId(gymListingId),
  });

  const { mutate: deleteById } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymNotificationService.deleteById(id),
  });

  const { mutate: updateSentDate } = useMutation<any, Error, string>({
    mutationFn: async (id) => GymNotificationService.updateSentDate(id),
  });

  return {
    deleteByGymListingId,
    deleteById,
    updateSentDate,
  };
};
